import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';

/**
 * Single application wide loading overlay. Rendered once in every app shell and
 * driven by LoaderService (HTTP interceptor + router navigation).
 */
@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {
  readonly isLoading$ = this.loaderService.loading$;
  isOverlayHost = false;

  constructor(private readonly loaderService: LoaderService) {}

  ngOnInit(): void {
    this.isOverlayHost = this.loaderService.claimOverlayHost();
  }

  ngOnDestroy(): void {
    if (this.isOverlayHost) {
      this.loaderService.releaseOverlayHost();
    }
  }
}
